const SEARCH_HANDOFF_KEY = 'search';

/**
 * Transient per-tab handoff of the current search query to `searchGuard`.
 *
 * The query is already applied to `QueryApiService` in memory before navigation;
 * this exists only so the search route can be reloaded in the same tab. Hence
 * sessionStorage (per-tab, survives reload, cleared with the tab) rather than
 * durable per-user storage. A blocked store degrades gracefully — the guard
 * bounces to home when the handoff is missing.
 */
export function writeSearchHandoff(query: unknown): void {
  try {
    sessionStorage.setItem(SEARCH_HANDOFF_KEY, JSON.stringify(query));
  } catch {
    /* private mode / blocked storage — guard bounces to home */
  }
}

export function readSearchHandoff<T = unknown>(): T | null {
  try {
    const raw = sessionStorage.getItem(SEARCH_HANDOFF_KEY);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}
